import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
     // 折叠状态（默认不折叠）
     isCollapsed: false
  },
  getters: {
    // 获取折叠状态（组件里可以 this.$store.getters.isCollapsed）
    isCollapsed: state => state.isCollapsed
  },
  mutations: {
      // 切换折叠状态
      toggleCollapsed(state) {
        state.isCollapsed = !state.isCollapsed
      },
      // 设置折叠状态（true/false）
      setCollapsed(state, val) {
        state.isCollapsed = val
      }
  },
  actions: {
     // 如果有异步逻辑，可以在这里写
        toggleCollapsed({ commit }) {
          commit('toggleCollapsed')
        },
        setCollapsed({ commit }, val) {
          commit('setCollapsed', val)
        }
  },
  modules: {
  }
})
